module.exports = __webpack_public_path__ + "img/bnr-spring2022-sp.6c3998b0.jpg";